import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { industries } from '../../data/industries';
import { SectionIntro } from '../layout/SectionIntro';
const accentHex = {
  orange: '#FF6B18',
  green: '#12C777',
  cyan: '#2BB6EE',
  blue: '#2F6BFF'
} as const;
const spanFor = {
  lg: 'sm:col-span-3 lg:col-span-4 lg:row-span-2',
  md: 'sm:col-span-3 lg:col-span-4',
  sm: 'sm:col-span-2 lg:col-span-2'
} as const;
export function IndustryWall() {
  return <section id="portfolio-teaser" className="relative overflow-hidden bg-navy-900 py-16 lg:py-24" data-id="element-243" data-mp="1c9liohkr7miq">
      <div className="absolute inset-0 dots opacity-[0.28]" aria-hidden="true" data-id="element-244" data-mp="1q8tmjnrv3it9" />

      <div className="relative mx-auto max-w-8xl px-5 sm:px-8 lg:px-10" data-id="element-245" data-mp="1l7nn773p4xar">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-246" data-mp="31lw2cgm504cd">
          <SectionIntro eyebrow="Portfolio" title={<>
                Industries we have already built for.
                <span className="block text-mist-300" data-id="element-248" data-mp="1wisavb993yg3">A printer and a chiropractor need different websites.</span>
              </>} body="Same approach every time: understand the work, then build around it. The details change completely from one industry to the next." data-id="element-247" data-mp="2wo3zwsnv8ztx" />
          <Link to="/portfolio" className="group inline-flex shrink-0 items-center gap-2 self-start rounded-xl border border-white/15 px-5 py-3 text-[14px] font-semibold text-white transition-colors hover:border-forge-cyan/60 hover:bg-white/5" data-id="element-249" data-mp="2agqqejzb60x6">
            View the portfolio
            <ArrowUpRightIcon className="h-4 w-4 text-forge-cyan transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-250" data-mp="1mrfk6mz6vebn" />
          </Link>
        </div>

        <div className="mt-12 grid auto-rows-[minmax(9.5rem,auto)] grid-cols-1 gap-3 sm:grid-cols-6 lg:grid-cols-12" data-id="element-251" data-mp="u41xdhp7fz59">
          {industries.map((industry, i) => <motion.article key={industry.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className={`group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-white/10 bg-navy-950/70 p-5 transition-colors hover:border-white/25 ${spanFor[industry.size]}`} data-id="element-252" data-mp="r2gpi7n3xl3x" data-mpi={i}>
              <span className="absolute inset-0 bp-fine opacity-50" aria-hidden="true" data-id="element-253" data-mp="430vfkzajp09" />
              <span className="absolute -right-8 -top-8 h-24 w-24 rounded-full opacity-[0.12] transition-opacity duration-500 group-hover:opacity-25" style={{
            backgroundColor: accentHex[industry.accent]
          }} aria-hidden="true" data-id="element-254" data-mp="i20n71i3ok0n" />

              <div className="relative flex items-center gap-2" data-id="element-255" data-mp="1oicm54sqy5xa">
                <span className="h-2 w-2 rotate-45" style={{
              backgroundColor: accentHex[industry.accent]
            }} aria-hidden="true" data-id="element-256" data-mp="1oi49ne0jd2mm" />
                <span className="font-mono text-[9.5px] uppercase tracking-[0.18em] text-mist-400" data-id="element-257" data-mp="3bf2cg7t0dvtk">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>

              <div className="relative mt-6" data-id="element-258" data-mp="2xhngslc5wrt5">
                <h3 className="font-display text-[16px] font-bold leading-snug text-white lg:text-[17px]" data-id="element-259" data-mp="32ff9viojmjyx">
                  {industry.name}
                </h3>
                <p className="mt-2 text-[12.5px] leading-relaxed text-mist-300" data-id="element-260" data-mp="3u5k03xyzi182">{industry.focus}</p>
              </div>

              <span className="absolute bottom-0 left-0 h-[2px] w-0 transition-all duration-500 group-hover:w-full" style={{
            backgroundColor: accentHex[industry.accent]
          }} aria-hidden="true" data-id="element-261" data-mp="3geyiecl9nxbr" />
            </motion.article>)}
        </div>
      </div>
    </section>;
}